import { useEffect, useState } from "react";
import { StyledProjectsContainer, StyledUserContainer } from "./User.styles";
import { getProjectsByUserId, getUserByUserId } from "../../Datahandler";
import { useDispatch, useSelector } from "react-redux";
import { addToast } from "../Shared/Toasts/redux/actions";
import { useNavigate } from "react-router-dom";
import ProjectCard from "../Projects/ProjectCard";
import extractNamesFromEmail from "../../utils/extractNameFromEmail";
import Members from "../Shared/Members";

const User = () => {
    const [projects, setProjects] = useState(null);

    const currentUser = useSelector(state => state.user.loggedInUser);
    const dispatch = useDispatch();
    const navigate = useNavigate();

    useEffect(() => {
        if (!currentUser) {
            // navigate("/login")
        }
        if (currentUser) {
            getProjectsByUserId(currentUser.uid).then((res) => {
                setProjects(res);
                console.log(projects)
            }).catch((err) => {
                dispatch(addToast({ header: "Failure", body: `Failed to fetch projects.`, time: Date.now(), status: 'failure', id: crypto.randomUUID() }))
            });
            getUserByUserId(currentUser.uid).then((res) => {
                console.log(res);
            })
        }
    }, [])

    return (
        currentUser ? <StyledUserContainer className="gallery-container">
            <Members memberIds={[currentUser.uid]} />
            <h2>Projects</h2>
            <p>{extractNamesFromEmail(currentUser.email)} has contributed to the following projects:</p>
            {projects && <StyledProjectsContainer>
                {projects.map(project => (
                    <ProjectCard
                        key={project.uid}
                        image={project.imgUrl}
                        title={project.title}
                        description={project.description} />
                ))}
            </StyledProjectsContainer>}
        </StyledUserContainer> : <p>please login</p>
    )
}

export default User;